<template>
  <div class="flex h-screen min-w-0 overflow-hidden overflow-x-hidden">
    <!-- 主内容区域 -->
    <div class="flex-1 min-w-0 flex flex-col bg-gray-100 overflow-hidden overflow-x-hidden">
      <!-- 头部 -->
      <div class="h-15 bg-blue-900 bg-opacity-85 flex justify-between items-center px-5 shadow-md z-50 text-blue-100">
        <!-- 左侧标题 -->
        <div class="flex items-center space-x-4">
          <div class="platform-title mr-5">
            <h3 class="text-white font-bold text-lg whitespace-nowrap">
              数据分析
            </h3>
          </div>
        </div>

        <!-- 右侧用户信息 -->
        <div class="flex items-center space-x-3">
          <span class="text-blue-100 text-sm">
            {{ username }}
          </span>
          <el-button 
            type="text" 
            size="small" 
            @click="logout"
            class="text-blue-100 hover:text-white"
          >
            退出登录
          </el-button>
        </div>
      </div>

      <!-- 主体内容 -->
      <div class="flex-1 overflow-auto flex flex-col">
        <!-- Analytics 按钮组 -->
        <div class="bg-white border-b border-gray-200 px-6 py-3 shadow-sm">
          <div class="flex items-center space-x-2 overflow-x-auto">
            <el-button
              :type="currentAnalyticsType === 'dashboard' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'dashboard' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('dashboard')"
              size="small"
            >
              <i class="el-icon-data-board"></i>
              <span>数据看板</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'deviation' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'deviation' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('deviation')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>桥梁偏航统计</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'superelevation' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'superelevation' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('superelevation')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>桥梁超高统计</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'overspeed' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'overspeed' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('overspeed')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>桥梁超速统计</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'traffic' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'traffic' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('traffic')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>流量统计</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'vhf' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'vhf' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('vhf')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>桥梁VHF统计</span>
            </el-button>
            <el-button
              :type="currentAnalyticsType === 'alert' ? 'primary' : 'text'"
              :class="[
                'flex items-center space-x-1',
                currentAnalyticsType === 'alert' 
                  ? 'bg-blue-600 text-white hover:bg-blue-700' 
                  : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
              ]"
              @click="handleAnalyticsMenuClick('alert')"
              size="small"
            >
              <i class="el-icon-data-line"></i>
              <span>桥梁预警统计</span>
            </el-button>
          </div>
        </div>
        
        <!-- 内容区域 -->
        <div class="flex-1 overflow-auto">
          <slot></slot>
        </div>
      </div>
      
      <!-- 底部 -->
      <div class="h-10 bg-blue-900 bg-opacity-85 flex justify-center items-center text-blue-100 text-xs border-t border-opacity-20 border-blue-300">
        <p>© 2025 桥卫士</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalyticsLayout',
  data() {
    return {
      username: localStorage.getItem('username') || '用户'
    }
  },
  computed: {
    currentAnalyticsType() {
      const path = this.$route.path;
      if (path.startsWith('/analytics/')) {
        return path.replace('/analytics/', '');
      }
      return 'dashboard';
    },
    currentAnalyticsMenuText() {
      const menuMap = {
        'dashboard': '数据看板',
        'deviation': '桥梁偏航统计',
        'superelevation': '桥梁超高统计', 
        'overspeed': '桥梁超速统计',
        'traffic': '流量统计',
        'forbid': '桥梁禁航统计',
        'vhf': '桥梁VHF统计',
        'alert': '桥梁预警统计'
      };
      return menuMap[this.currentAnalyticsType] || '数据分析';
    }
  },
  methods: {
    handleAnalyticsMenuClick(command) {
      if (command === 'dashboard') {
        this.$router.push('/analytics/dashboard');
      } else {
        this.$router.push(`/analytics/${command}`);
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
/* 按钮组样式优化 */
.el-button--small {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.el-button--small i {
  margin-right: 4px;
}
</style>
